import { render } from "./Loading.vue?vue&type=template&id=1b23e077&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=1b23e077&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/AS3/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b23e077"]])

export default __exports__